export const getShadowTooltipContainer = (trigger: HTMLElement) => trigger.parentElement ?? trigger

export const defaultTooltipStyles = {
	body: { fontSize: 12, lineHeight: "16px", padding: "6px 8px", minHeight: "auto" },
}

export const compactTooltipStyles = {
	body: { fontSize: 10, lineHeight: "12px", padding: "3px 6px", minHeight: "auto" },
}
